// removed by extract-text-webpack-plugin
module.exports = {"root":"ButtonBoolean-module__root__9i5Gz","revertOrder":"ButtonBoolean-module__revertOrder___hLws","button":"ButtonBoolean-module__button__6_6qW","buttonTrue":"ButtonBoolean-module__buttonTrue__1w9zm","buttonFalse":"ButtonBoolean-module__buttonFalse__2IIJn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FieldBoolean/ButtonBoolean/ButtonBoolean.module.css
// module id = 1783
// module chunks = 0